import React, {Component} from 'react';
import Dialog from './Dialog';
import './ConfirmDialog.css';
import {connect} from 'react-redux';
import actions from './confirmation.actions';

class ConfirmDialog extends Component {
	render() {
		const {
			onYes,
			onNo,
			onContinue,
			onLater,
			onConfirm,
			onCancel,
			confirmation: {title, message, buttons}
		} = this.props;

		return (
			<Dialog
				className="ConfirmDialog compact"
				onYes={onYes}
				onNo={onNo}
				onContinue={onContinue}
				onLater={onLater}
				onConfirm={onConfirm}
				onCancel={onCancel}
				title={title}
				buttons={buttons}
				emphasis={buttons[0]}>
				<div className="ConfirmDialog-body">
					<h1>
						<span className="icon icon-info" />
						{title}
					</h1>
					<p>{message}</p>
				</div>
			</Dialog>
		);
	}
}

const ConnectedConfirmDialog = connect(
	({confirmation}) => ({
		confirmation
	}),
	dispatch => ({
		onConfirm: () => dispatch(actions.confirm()),
		onCancel: () => dispatch(actions.cancel()),
		onContinue: () => dispatch(actions.continue()),
		onLater: () => dispatch(actions.later()),
		onYes: () => dispatch(actions.yes()),
		onNo: () => dispatch(actions.no())
	})
)(ConfirmDialog);

export default ConnectedConfirmDialog;



// WEBPACK FOOTER //
// ./src/widgets/ConfirmDialog.js